import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'

type DataObject = Record<string, any>

const Heading3 = ({ children }: { children: React.ReactNode }) => <h3 className="mt-4">{children}</h3>
const Paragraph = ({ children }: { children: React.ReactNode }) => (
  <p className="mt-2 max-w-[340px] text-[22px] leading-[30px]">{children}</p>
)

const SocialProofCustomers = ({ item }: { item: DataObject }) => {
  return (
    <div>
      <p className="uppercase text-primary-green-85">{item.type}</p>

      <div className="flex flex-col-reverse lg:flex-row">
        <div className="lg:w-2/3 lg:pr-14">
          <PrismicRichText
            field={item.title}
            components={{
              heading3: ({ children }) => <Heading3>{children}</Heading3>,
            }}
          />
          <PrismicRichText
            field={item.description}
            components={{
              paragraph: ({ children }) => <Paragraph>{children}</Paragraph>,
            }}
          />

          <div className="mt-10 flex flex-col justify-center">
            <span className="block font-halyardDisplay text-base">{item.client_name}</span>
            <span className="block font-halyardText text-sm text-primary-ink-60">{item.client_designation}</span>
            <span className="block font-halyardText text-sm text-primary-ink-60">{item.client_organization}</span>
          </div>
        </div>

        <div className="mb-4 lg:mb-0 lg:w-1/3">
          <PrismicNextImage field={item.client_logo} className="h-auto max-w-full lg:scale-150" fallbackAlt="" />
        </div>
      </div>
    </div>
  )
}

export default SocialProofCustomers
